// config.ts
const config = {
    apiBaseUrl: 'https://willsoarap.azurewebsites.net/api/',

   
  };
  
  export default config;
  
